import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Typography, CircularProgress, Box } from '@mui/material';
import PlanEditor from '../components/PlanEditor';
import instance from '../utils/axiosConfig';

const EditPlanPage = () => {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { planId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        const response = await instance.get(`/api/mp/${planId}`);
        const data = response.data;
        if (data.success) {
          setPlan(data.plan);
        } else {
          setError('Error al cargar el plan');
        }
      } catch (error) {
        setError('Error al cargar el plan');
      } finally {
        setLoading(false);
      }
    };

    fetchPlan();
  }, [planId]);

  const handleSave = async (updatedPlan) => {
    // Handle successful update
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error || !plan) {
    return (
      <Container>
        <Typography color="error">{error || 'Plan no encontrado'}</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <PlanEditor plan={plan} onSave={handleSave} />
    </Container>
  );
};

export default EditPlanPage; 